import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "video-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.92761 9.90733C8.92761 8.74661 10.1905 8.0235 11.1914 8.61579L15.0734 10.9118C16.0553 11.4921 16.055 12.9138 15.073 13.4941L11.1914 15.7899C10.1905 16.3822 8.92761 15.6591 8.92761 14.4983V9.90733ZM14.3097 12.2028L10.4276 14.4983V9.90733L14.3097 12.2028Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8 2.25C4.82436 2.25 2.25 4.82436 2.25 8V16C2.25 19.1756 4.82436 21.75 8 21.75H16C19.1756 21.75 21.75 19.1756 21.75 16V8C21.75 4.82436 19.1756 2.25 16 2.25H8ZM3.75 8C3.75 5.65279 5.65279 3.75 8 3.75H16C18.3472 3.75 20.25 5.65279 20.25 8V16C20.25 18.3472 18.3472 20.25 16 20.25H8C5.65279 20.25 3.75 18.3472 3.75 16V8Z"
    }, null, -1)
  ])))
}
export default { render: render }